<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <ai-message-vetting-agents-list
                v-if="FEATURES.contact_groups && (hash === 'ai-message-vetting-agents' || !hash)"
            />
            <ai-configuration
                v-else-if="(FEATURES.message_hub_ai || FEATURES.quick_blast_ai) && hash === 'ai-configuration'"
                :ownsTeam="isAdminOrOwner"
            />
        </div>
    </page-container>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import PageContainer from '~/components/general/PageContainer.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import AiMessageVettingAgentsList from './ai-message-vetting-agents/list/AiMessageVettingAgentsList.vue';
import AiConfiguration from '../integrations/ai-configuration/AiConfiguration.vue';
import { useSettingsHash } from '~/composables/useSettingsHash';

const FEATURES = inject<Record<string, boolean>>('FEATURES', {});
const { hash, content } = useSettingsHash();

const isAdminOrOwner = Spark.isAdminOrOwner;
</script>
